// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","ListItemIcon":"bcb_a bhl_kb","ListItemIcon--empty":"bcb_b bhl_fj"};